import voca from 'voca';

function isStringNumeric(value) {
  return /^\d+(\.\d+)?$/.test(String(value));
}

function titleize(string) {
  return voca.titleCase(voca.kebabCase(string).replace(/-/g, ' '));
}

function escapeDoubleQuotes(word) {
  return word.replace(/&ldquo;|&rdquo;/g, '"');
}

export { isStringNumeric, titleize, escapeDoubleQuotes };
